import 'scripts/bem'

// load the stylin
import '../_bundles/essential.css'

// load the common blocks
import * as blocks from '../_bundles/essential.js'

// load the run script
import Compiler from 'scripts/run.js'

Compiler.run(blocks)
